/**
 * 개발 모드에서만 목 서버를 켠다.
 *
 * 프로덕션 번들에는 들어가면 안 된다 — webpack DefinePlugin 이 넣는
 * process.env.NODE_ENV 분기로 트리셰이킹된다.
 */
export async function startMockWorker(): Promise<void> {
  if (process.env.NODE_ENV === 'production') return;

  const { worker } = await import('./browser');
  await worker.start({
    // 목이 없는 요청(정적 파일 등)은 그대로 통과시킨다
    onUnhandledRequest: 'bypass',
    quiet: true,
  });
}
